document.addEventListener('DOMContentLoaded', () => {
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.15
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('piro-in-view');
        observer.unobserve(entry.target); // Play once
      }
    });
  }, observerOptions);

  // Auto-attach animation classes to key elements to avoid manual HTML editing
  const animatedElements = document.querySelectorAll('.piro-section .piro-container, .piro-hero__content > *, .piro-collections-grid > *, .piro-fs-grid > *');
  
  animatedElements.forEach((el, index) => {
    el.classList.add('piro-fade-up');
    observer.observe(el);
  });

  // Also observe elements that already have the class hardcoded in liquid files
  const hardcodedElements = document.querySelectorAll('.piro-fade-up');
  hardcodedElements.forEach(el => observer.observe(el));
});
